export const LOAD_PRICE_RULES_SETTINGS = 'LOAD_PRICE_RULES_SETTINGS'
export const LOAD_PRICE_RULES_SETTINGS_SUCCESS = 'LOAD_PRICE_RULES_SETTINGS_SUCCESS'
export const LOAD_PRICE_RULES_SETTINGS_FAILED = 'LOAD_PRICE_RULES_SETTINGS_FAILED'

export const UPDATE_PRICE_RULES_SETTINGS = 'UPDATE_PRICE_RULES_SETTINGS'
export const UPDATE_PRICE_RULES_SETTINGS_SUCCESS = 'UPDATE_PRICE_RULES_SETTINGS_SUCCESS'
export const UPDATE_PRICE_RULES_SETTINGS_FAILED = 'UPDATE_PRICE_RULES_SETTINGS_FAILED'

export const LOAD_PRICE_RULES = 'LOAD_PRICE_RULES'
export const LOAD_PRICE_RULES_SUCCESS = 'LOAD_PRICE_RULES_SUCCESS'
export const LOAD_PRICE_RULES_FAILED = 'LOAD_PRICE_RULES_FAILED'

export const CREATE_PRICE_RULE = 'CREATE_PRICE_RULE'
export const CREATE_PRICE_RULE_SUCCESS = 'CREATE_PRICE_RULE_SUCCESS'
export const CREATE_PRICE_RULE_FAILED = 'CREATE_PRICE_RULE_FAILED'

export const UPDATE_PRICE_RULE = 'UPDATE_PRICE_RULE'
export const UPDATE_PRICE_RULE_SUCCESS = 'UPDATE_PRICE_RULE_SUCCESS'
export const UPDATE_PRICE_RULE_FAILED = 'UPDATE_PRICE_RULE_FAILED'

export const DELETE_PRICE_RULE = 'DELETE_PRICE_RULE'
export const DELETE_PRICE_RULE_SUCCESS = 'DELETE_PRICE_RULE_SUCCESS'
export const DELETE_PRICE_RULE_FAILED = 'DELETE_PRICE_RULE_FAILED'
